import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import isNode from 'detect-node'
import { Container } from './styled'
import WhiteLabelMenus from './WhiteLabelMenus'
import OrderParty from 'components.v2/OrderParty'
import WhiteLabelVendorHeader from './WhiteLabelVendorHeader'
import VenueImage from 'components.v2/VenueImage'
import WhiteLabelViewOrder from './WhiteLabelViewOrder'

class Mobile extends React.Component {
  render() {
    const {
      selectedOrders,
      info,
      history,
      openModal,
      orderQuantity,
      orderPrice,
    } = this.props

    return (
      <Fragment>
        <WhiteLabelVendorHeader history={history} {...info} />
        <Container>
          {info.id && (
            <VenueImage
              shouldUseCoverImg
              ratio={[375, 185]}
              hasStatus
              {...info}
            />
          )}
          {isNode ? null : <OrderParty />}
          <WhiteLabelMenus
            addToOrder={this.addToOrder}
            selectedOrders={selectedOrders}
            openModal={openModal}
          />
        </Container>
        {selectedOrders.length > 0 && (
          <WhiteLabelViewOrder
            orderQuantity={orderQuantity}
            orderPrice={orderPrice}
          />
        )}
      </Fragment>
    )
  }
}

Mobile.propTypes = {
  orderQuantity: PropTypes.number,
  orderPrice: PropTypes.number,
  match: PropTypes.object,
  info: PropTypes.object,
  history: PropTypes.object,
  selectedOrders: PropTypes.array,
  openModal: PropTypes.func,
}

export default withRouter(Mobile)
